export default __webpack_public_path__ + "static/media/hero-s.239b33d3.jpg";